import React from 'react';
import ReactSlick from 'react-slick';
import ArrowSvg from '../../icons/ArrowSvg';
import SmartImage from '../../subcomponents/SmartImage';
import findAltText from '../../utils';


import './doorSlider.scss';

class DoorSlider extends React.PureComponent {
  constructor(props) {
    super(props);
    this.prevArrow = React.createRef();
    this.nextArrow = React.createRef();
    this.handleArrows = this.handleArrows.bind(this);
    this.showArrows = window.innerWidth >= 768;
    this.state = {
      activeModal: -1,
      doorList: [],
      translations: window.campaign_data.campaign_translations.blocks,
    };
  }

  componentDidMount() {
    this.handleArrows();
    const {
      imageId, imageType, content, modalIds = '',
    } = this.props.element;
    const imagesIdArray = imageId.split(',');

    this.setState({
      doorList: imagesIdArray.map((el) => {
        return {
          name: `${content}${el}text`,
          pictureName: `${content}-${el}${imageType || '.jpg'}?version=${this.props.version}`,
          link: `${content}${el}link`,
          isModal: modalIds.includes(el),
          number: el,
        };
      }),
    });
  }

  hideModal = (e) => {
    if (!this.hasClass(e.target, 'youtube-holder')) {
      document.querySelector('body').removeEventListener('click', this.hideModal);
      this.setState({
        activeModal: -1,
      });
    }
  }

  handleArrows() {
    if (this.showArrows) {
      if (this.swiper) {
        this.nextArrow.current.style.display = 'flex';
        this.prevArrow.current.style.display = 'flex';
      }
      if (this.swiper && this.swiper.isBeginning) {
        this.prevArrow.current.style.display = 'none';
      }
      if (this.swiper && this.swiper.isEnd) {
        this.nextArrow.current.style.display = 'none';
      }
    }
  }

  hasClass(element, className) {
    return (` ${element.className} `).indexOf(` ${className} `) > -1;
  }

  showModal(index) {
    document.querySelector('body').addEventListener('click', this.hideModal);
    this.setState({
      activeModal: index,
    });
  }

  renderModal(index) {
    return (
    <div className="youtube-holder">
      <div className="iframe-close">
        <span className="close" onClick={() => this.hideModal} role="button" tabIndex="0">x</span>
      </div>
      <iframe
        title="Youtube Video"
        align="middle"
        src={`https://www.youtube.com/embed/${this.state.translations[this.state.doorList[index].link]}?&modestbranding=1&rel=0`}
      />
    </div>
    );
  }

  render() {
    const uppercaseLetters = this.props.url.generalData ?
      this.props.url.generalData.uppercaseLetters
      : false;
    const { campaignType, order, version } = this.props;
    const {
      hide, 
      content, 
      slidesPerViewDesktop, 
      slidesPerViewMobile, 
      titleColor,
      useSubtitle, 
      subtitleColor, 
      useSliderText, 
      sliderTextColor, 
      mobileTitleColor,
      useMobileText,
      useSavings, 
      svgArrowColor, 
      anchorName, 
      titleHTag,
      backgroundImage, 
      backgroundContent, 
      type, 
      noBackground, 
      doorSliderNumber,
      useGradient, 
      backgroundGradient, 
      gradientDirection, 
      backgroundColor,
      } = this.props.element;

    const { slug, imagePattern } = this.props.url;
    const { translations } = this.state;

    let displayTitleColor = titleColor;
    if (useMobileText && window.innerWidth < 768) displayTitleColor = mobileTitleColor;

    // change HTML tag of the component title for seo purpose
    const classes = uppercaseLetters ? 'doorslider-title title title--uppercase' : 'doorslider-title title';
    const titleTranslation = translations[`${content}title`];
    const titleObj = {
      h2: <h2 className={classes} style={{ color: displayTitleColor }}>{titleTranslation}</h2>,
      h3: <h3 className={classes} style={{ color: displayTitleColor }}>{titleTranslation}</h3>,
      p: <p className={classes} style={{ color: displayTitleColor }}>{titleTranslation}</p>,
    };
    const title = titleObj[titleHTag];

    // slick slider arrows
    const PrevArrow = ({ className, onClick }) => {
      return (
        <div className={`${className} arrowLeft arrowSlider`} aria-label="Previous Slide" onClick={onClick} role="button" tabIndex="0">
            <ArrowSvg svgColor={svgArrowColor} />
        </div>
      );
    };
    const NextArrow = ({ className, onClick }) => {
      return (
        <div className={`${className} arrowRight arrowSlider`} aria-label="Next Slide" onClick={onClick} role="button" tabIndex="0">
            <ArrowSvg svgColor={svgArrowColor} />
        </div>
      );
    };

    const params = {
      slidesToShow: Number(slidesPerViewMobile),
      slidesToScroll: Math.floor(Number(slidesPerViewMobile)),
      dots: true,
      arrows: true,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      infinite: false,
      lazyLoad: true,
      touchThreshold: 15,
      speed: 300,
      customPaging: () => (
        <div
          className="dot"
          style={{
            backgroundColor: svgArrowColor,
          }}
        />
      ),
      responsive: [
        {
          breakpoint: 3000,
          settings: {
            slidesToShow: Number(slidesPerViewDesktop),
            slidesToScroll: Math.floor(Number(slidesPerViewDesktop)),
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: Number(slidesPerViewMobile),
            slidesToScroll: Math.floor(Number(slidesPerViewMobile)),
          },
        },
      ],
    };

    const stylelist = ['mainWidth'];
    if (campaignType === 'sale' || noBackground) { stylelist.push('sale'); }
    if (backgroundImage) { stylelist.push('background-image-style'); }
    let styler = {};
     if (noBackground && useGradient && gradientDirection === 'leftToRight') {
       styler = { background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && useGradient && gradientDirection === 'topToBottom') {
       styler = { background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && !useGradient) {
       styler = { background: backgroundColor };
    } else {
       styler = {};
        }
    let component = null;
    if (!hide) {
      component = (
        <section
          id={campaignType === 'sale' || campaignType === 'general' ? anchorName : ''}
          className="component doorslider-section"
          style={styler}
          dataorder={order}
          datatype={type}
        >
          {(backgroundImage || (campaignType === 'general' && !noBackground)) &&
            <SmartImage
              slug={slug}
              name={campaignType === 'general' ? `340-door-slider${doorSliderNumber}${imagePattern}` : `${backgroundContent}.jpg`}
              version={version}
              campaignType={campaignType}
              className={campaignType === 'general' ? 'heightBackground' : ''}
              alt={findAltText(`Door Slider Background ${doorSliderNumber}`, translations[`${content}title`])}
            />
          }
          <div className={stylelist.join(' ')}>
            <div className={campaignType === 'general' && !noBackground ? 'doorslider-component div-absolute' : 'doorslider-component'}>
              { title }
            { useSubtitle &&
              <h3 className="doorslider-title subtitle" style={{ color: subtitleColor }}>{translations[`${content}subtitle`]}</h3>
            }
            <ReactSlick {...params}>
              {this.state.doorList.length > 0 && this.state.doorList.map((door, index) => {
                const aProps = {
                  className: 'door-holder door-holder-slider',
                  key: translations[door.link],
                };

                if (door.isModal) {
                  aProps.onClick = () => this.showModal(index);
                } else {
                  aProps.href = translations[door.link];
                }

                return (
                  <a {...aProps}>
                    <div className="image-holder">
                      {window.innerWidth <= 767 ?
                        <img src={`${slug + content}s/mobile/${door.pictureName}`} alt={findAltText(`Door Slider ${door.number} ${doorSliderNumber}`, translations[door.name])} className="doorslider-image" />
                        :
                        <img src={`${slug + content}s/desktop/${door.pictureName}`} alt={findAltText(`Door Slider ${door.number} ${doorSliderNumber}`, translations[door.name])} className="doorslider-image" />
                      }
                    </div>

                    <div className="text-block">
                      {useSavings && <p className="doorslider-savings savings text">
                      {/* {door.minimum && translations.minimum}
                      {door.saveUpTo && translations.saveupto}
                      {this.props.translations[door.savings]} */}
                                     </p> }
                      {useSliderText && <p className="doorslider-text text" style={{ color: sliderTextColor }}>{translations[door.name]}</p>}
                    </div>
                  </a>
                );
              })}

            </ReactSlick>
            {this.state.activeModal >= 0 &&
              this.renderModal(this.state.activeModal)
            }
            </div>
          </div>
        </section>
        );
      }
    return (
      component
    );
  }
}

export default DoorSlider;
